import * as React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import CRUDDataTable from 'dashboard/containers/CRUDDataTable';
import { getAllCategoryToursDashboard } from 'dashboard/_redux/actions/categoryTours';
import { useTourCategoriesList } from './useTourCategoriesList';
import './_TourCategoriesPage.scss';

const TourCategoriesPage: React.FC = () => {
  const {
    categoryTours,
    loaded,
    dataTableRef,
    columns,
    isCreateModalOpen,
    formData,
    handleOpenCreateModal,
    handleCloseCreateModal,
    handleInputChange,
    handleSubmitCreate,
  } = useTourCategoriesList();

  const [t] = useTranslation();

  return (
    <>
      <div className="tour-categories-page">
        <div className="categories-card card card-body">
          <CRUDDataTable
            myRef={dataTableRef}
            loading={!loaded}
            data={categoryTours}
            title={t('dashboard.categoryTourPage.title') || 'Catégories de Tours'}
            columns={columns}
            fetchDataFn={getAllCategoryToursDashboard}
            onAddButtonClick={handleOpenCreateModal}
          />
        </div>
      </div>

      {/* Modal de création - Rendu via Portal */}
      {isCreateModalOpen && ReactDOM.createPortal(
        <div
          className="ream-modal show"
          style={{ display: 'block' }}
          onClick={handleCloseCreateModal}
        >
          <div className="ream-modal-dialog ream-modal-centered" onClick={(e) => e.stopPropagation()}>
            <div className="ream-modal-content">
              <div className="ream-modal-header">
                <h5 className="modal-title">
                  {t('dashboard.categoryTourPage.createTitle') || 'Créer une catégorie de parcours'}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseCreateModal}
                  aria-label="Close"
                />
              </div>
              <form onSubmit={handleSubmitCreate}>
                <div className="ream-modal-body">
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label htmlFor="name" className="form-label">
                        {t('dashboard.categoryTourPage.name') || 'Nom'} * (FR)
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        placeholder="Ex: Aventure, Culture, Nature..."
                      />
                    </div>

                    <div className="col-md-12 mb-3">
                      <label htmlFor="name_en" className="form-label">
                        {t('dashboard.categoryTourPage.name') || 'Nom'} (EN)
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name_en"
                        name="name_en"
                        value={formData.name_en || ''}
                        onChange={handleInputChange}
                        placeholder="Ex: Adventure, Culture, Nature..."
                      />
                    </div>

                    <div className="col-md-12 mb-3">
                      <label htmlFor="description" className="form-label">
                        {t('dashboard.categoryTourPage.description') || 'Description'} * (FR)
                      </label>
                      <textarea
                        className="form-control"
                        id="description"
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                        rows={4}
                        required
                        placeholder="Décrivez cette catégorie de parcours..."
                      />
                    </div>

                    <div className="col-md-12 mb-3">
                      <label htmlFor="description_en" className="form-label">
                        {t('dashboard.categoryTourPage.description') || 'Description'} (EN)
                      </label>
                      <textarea
                        className="form-control"
                        id="description_en"
                        name="description_en"
                        value={formData.description_en || ''}
                        onChange={handleInputChange}
                        rows={4}
                        placeholder="Describe this tour category..."
                      />
                    </div>
                  </div>
                </div>
                <div className="ream-modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCloseCreateModal}
                  >
                    {t('dashboard.categoryTourPage.cancelButton') || 'Annuler'}
                  </button>
                  <button type="submit" className="btn btn-primary">
                    {t('dashboard.categoryTourPage.createButton') || 'Créer'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default TourCategoriesPage;
